<template>
  <v-layout justify-center align-center>
    <v-container class="text-center">
      <v-card class="ma-12">
        <v-card-title>
          <h1>Login</h1>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-alert type="info" v-if="loginFailed">{{ loginFailed }}</v-alert>

            <v-text-field
              label="Nutzername"
              prepend-icon="mdi-account-circle"
              v-model="input.username"
            />
            <v-text-field
              label="Passwort"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              v-model="input.password"
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="loginBtnClicked" color="info">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import authApi from "../api/auth.js";

export default {
  name: "theLogin",

  data: function() {
    return {
      showPassword: false,
      input: {
        username: "",
        password: ""
      },
      loginFailed: false
    };
  },

  // check if user is already/ still logged in
  created() {
    if (localStorage.getItem("jwt") != null) {
      this.$router.push("./Sales-dashboard");
    }
  },

  methods: {
    loginBtnClicked: async function(e) {
      e.preventDefault();
      if (this.input.username != "" && this.input.password != "") {
        try {
          const response = await authApi.login(
            this.input.username,
            this.input.password
          );

          if (response.data.success == true) {
            localStorage.setItem("jwt", response.data.access_token);
            if (localStorage.getItem("jwt") != null) {
              this.$router.push("./Sales-dashboard");
            }
          } else {
            this.loginFailed =
              "Der Nutzername und/oder das Passwort ist falsch.";
            // if login fails, delete token from localStorage
            delete localStorage.jwt;
          }
        } catch (err) {
          console.log(err);
          this.loginFailed =
            "Prüfen Sie Ihre Internetverbindung! Sollten weiterhin Probleme bestehen, wenden Sie sich an den IT Support!";
          // if login fails, delete token from localStorage
          delete localStorage.jwt;
        }
      } else {
        this.loginFailed = "Bitte den Nutzernamen und das Passwort eingeben.";
      }
    }
  }
};
</script>
